import { TransportTypeFilterComponent } from '@/scopes/search/components/TransportTypeFilterComponent'
import {
  isLoadingSelector,
  transportTypeFilterOptionsSelector,
} from '@/scopes/search/quick-search/components/selectors'
import { useQuickSearchSelector } from '@/scopes/search/quick-search/infrastructure/store/useQuickSearchSelector'
import * as React from 'react'

export function TransportTypeFilter({
  onConfirm,
}: {
  onConfirm: (selection: string) => void
}) {
  const transportTypeOptions = useQuickSearchSelector(transportTypeFilterOptionsSelector)
  const isLoading = useQuickSearchSelector(isLoadingSelector)
  return (
    <TransportTypeFilterComponent
      id="transport-type-filter"
      onConfirm={onConfirm}
      options={transportTypeOptions.options}
      selectedOption={transportTypeOptions.selectedOption}
      disabled={isLoading || transportTypeOptions.options.length === 0}
      biggerBreakpoint
    />
  )
}
